import React from "react";
import { InputField } from "./InputFields.style";

interface NameFieldProps {
  value: string;
  label: string;
  onChange: (field: string, value: string) => void;
}

export const NameField: React.FC<NameFieldProps> = ({
  value,
  label,
  onChange,
}) => {
  return (
    <InputField
      fullWidth
      id="outlined-basic"
      label={label}
      variant="outlined"
      value={value}
      slotProps={{
        htmlInput: { "data-testid": "broadcast-name", maxLength: 25 },
      }}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        onChange("name", event.target.value);
      }}
    />
  );
};
